import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showToast, setShowToast] = useState(false);
  const [readyCount, setReadyCount] = useState(0);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const token = localStorage.getItem('token');
        const r = await axios.get('/api/orders/counts', { headers: { Authorization: `Bearer ${token}` } });
        setReadyCount(r.data.ready || 0);
      } catch(e) {}
    };
    fetchCounts();
    const interval = setInterval(fetchCounts, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const today = new Date();
    const isFirstDay = today.getDate() === 1;
    const lastShown = localStorage.getItem('financeToastShown');
    const thisMonth = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}`;
    if (isFirstDay && lastShown !== thisMonth) {
      setShowToast(true);
    }
  }, []);

  const closeToast = () => {
    const today = new Date();
    const thisMonth = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}`;
    localStorage.setItem('financeToastShown', thisMonth);
    setShowToast(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    navigate('/login');
  };

  const menus = [
    { path: '/dashboard', label: '대시보드', color: '#378ADD' },
    { path: '/categories', label: '카테고리 관리', color: '#04342C', children: [
      { path: '/categories', label: '카테고리 관리' },
      { path: '/categories/openmarket-matching', label: '오픈마켓 매칭' },
      { path: '/categories/notification', label: '고시정보 관리' },
    ]},
    { path: '/products/register', label: '상품등록', color: '#9B59B6', children: [
      { path: '/products/register', label: '신규 등록' },
      { path: '/products/register/bulk', label: '엑셀 일괄등록' },
      { path: '/products/register/match', label: '매칭스토어 등록', external: true },
    ]},
    { path: '/products', label: '상품 관리', color: '#EF9F27' },
    { path: '/products/send', label: '상품 전송', color: '#B04AA0' },
    { path: '/orders', label: '주문 관리', color: '#1D9E75', children: [
      { path: '/orders?status=ready', label: '구매준비', badge: true },
      { path: '/orders?status=hold', label: '구매보류' },
      { path: '/orders?status=buy', label: '구매완료' },
      { path: '/orders?status=ship', label: '배송중' },
      { path: '/orders?status=done', label: '배송완료' },
      { path: '/orders?status=claim', label: '반품·교환 진행중' },
      { path: '/orders?status=refund_done', label: '반품·교환 완료' },
      { path: '/orders?status=cancel', label: '주문취소' },
    ]},
    { path: '/sales', label: '매출 관리', color: '#7F77DD', children: [
      { path: '/sales', label: '매출현황' },
      { path: '/finance', label: '재무표' },
    ]},
    { path: '/settings', label: '설정', color: '#888780' },
    { path: '/alimtalk', label: '알림톡 내역', color: '#0064FF' },
    { path: 'https://smartstore.naver.com/byeolmanshop', label: '내 상점 (네이버)', color: '#1D9E75', external: true },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f5f5' }}>
      <div style={{
        width: '160px',
        background: '#fff',
        borderRight: '0.5px solid #e8e8e8',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0
      }}>
        <div style={{ padding: '16px', borderBottom: '0.5px solid #e8e8e8' }}>
          <div style={{ fontSize: '13px', fontWeight: '500', color: '#1a1a1a' }}>판매 관리</div>
          <div style={{ fontSize: '11px', color: '#aaa', marginTop: '2px' }}>jinhalife.co.kr</div>
        </div>
        <nav style={{ padding: '8px', flex: 1 }}>
          {menus.map(menu => (
            <div key={menu.path}>
              {menu.external && <div style={{ height: '8px' }} />}
          <button
                onClick={() => !menu.children && (menu.external ? window.open(menu.path, '_blank') : navigate(menu.path))}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '7px 10px',
                  borderRadius: '8px',
                  fontSize: '12px',
                  color: (menu.children ? menu.children.some(c => location.pathname === c.path) : location.pathname === menu.path) ? '#1a1a1a' : '#888',
                  background: (menu.children ? menu.children.some(c => location.pathname === c.path) : location.pathname === menu.path) ? '#f5f5f5' : 'none',
                  fontWeight: (menu.children ? menu.children.some(c => location.pathname === c.path) : location.pathname === menu.path) ? '500' : '400',
                  border: 'none',
                  width: '100%',
                  textAlign: 'left',
                  cursor: menu.children ? 'default' : 'pointer',
                  marginBottom: '2px'
                }}
              >
                <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: menu.color, flexShrink: 0 }} />
                {menu.label}
              </button>
              {menu.children && (
                <div style={{ paddingLeft: '24px', marginBottom: '4px' }}>
                  {menu.children.map(child => {
                    const childSearch = child.path.includes('?') ? child.path.split('?')[1] : '';
                    const isActive = location.pathname === '/orders' && location.search === (childSearch ? '?' + childSearch : '');
                    return (
                      <button
                        key={child.path}
                        onClick={() => child.external ? window.open(child.path, '_blank') : navigate(child.path)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '6px',
                          padding: '5px 10px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          color: isActive ? '#1a1a1a' : '#888',
                          background: isActive ? '#f5f5f5' : 'none',
                          fontWeight: isActive ? '500' : '400',
                          border: 'none',
                          width: '100%',
                          textAlign: 'left',
                          cursor: 'pointer',
                          marginBottom: '1px'
                        }}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '10px', color: '#ccc' }}>└</span>
                          {child.label}
                        </span>
                        {child.badge && readyCount > 0 && (
                          <span style={{ fontSize: '10px', background: '#E24B4A', color: '#fff', borderRadius: '10px', padding: '1px 6px', fontWeight: '500' }}>{readyCount}</span>
                        )}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </nav>
        <div style={{ padding: '12px' }}>
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '7px',
              borderRadius: '8px',
              border: '0.5px solid #e8e8e8',
              background: 'none',
              fontSize: '11px',
              color: '#888',
              cursor: 'pointer'
            }}
          >
            로그아웃
          </button>

        </div>
      </div>
      <div style={{ flex: 1, padding: '20px', minWidth: 0 }}>
        {showToast && (
          <div style={{ position: 'fixed', bottom: '24px', right: '24px', background: '#1D9E75', color: '#fff', borderRadius: '12px', padding: '14px 18px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', zIndex: 9999, maxWidth: '320px', fontSize: '13px', lineHeight: '1.6' }}>
            <div style={{ fontWeight: '500', marginBottom: '6px' }}>📊 재무표 저장 알림</div>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>말일 이후 구매 완료 후 재무표를 저장해주세요.</div>
            <button onClick={closeToast} style={{ marginTop: '10px', fontSize: '11px', padding: '4px 12px', borderRadius: '6px', border: 'none', background: 'rgba(255,255,255,0.2)', color: '#fff', cursor: 'pointer', width: '100%' }}>닫기</button>
          </div>
        )}
        {children}
        <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '0.5px solid #e8e8e8', textAlign: 'center', fontSize: '11px', color: '#bbb', lineHeight: '1.8' }}>
          <div>대표 : 한경우 &nbsp;|&nbsp; 사업자등록번호 : 111-13-96937 &nbsp;|&nbsp; 통신판매업신고 : 제2025-광주서구-0008호</div>
          <div>© {new Date().getFullYear() === 2026 ? '2026' : `2026-${new Date().getFullYear()}`} 진하유통. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
